<template>
  <div class="gesetzContainer grid-x" v-bind:class="{ normlistVisible: normlistVisible, showRegistrationWall: showRegistrationWall, showPaywall: showPaywall }">
    <div class="small-12 medium-4 cell gesetzContainer_side">
      <div class="gesetz-meta" @click="toggleNormlist()">
        <h1 class="gesetz-kurzname">{{ law.gesetz.id }}</h1>
        <div class="normlist-toggle"></div>

        <h2 v-if="law.gesetz.short" class="gesetz-name">{{ law.gesetz.short }}</h2>
        <h2 v-else class="gesetz-name">{{ law.gesetz.name }}</h2>
        <p v-if="law.gesetz.short && law.gesetz.name!=law.gesetz.short" class="gesetz-langname">{{ law.gesetz.name }}</p>
        <div class="gesetz-daten">
          <p v-if="law.gesetz.ausf">Vom {{ law.gesetz.ausf }}</p>
          <p v-if="law.gesetz.neuf">Neugefasst am {{ law.gesetz.neuf }}</p>
          <p v-if="law.gesetz.stand">Zuletzt geändert am {{ law.gesetz.stand }}</p>
          <p v-if="law.gesetz.scope">Geltungsbereich: {{ law.gesetz.scope }}</p>
          <p v-if="law.gesetz.in_kraft">{{ law.gesetz.in_kraft }}</p>
        </div>
      </div>
      <div class="normlist" id="normlist">
        <div v-for="(norm, index) in law.norms" v-bind:class="{ active: norm.isActive }">
          <div v-if="norm.isActive" ref="active"></div>
          <div v-if="norm.h.length>0" class="ueberschrifts">
            <div v-for="ueberschrift in norm.h">
              <div class="ueberschrift-bez">{{ ueberschrift.bez }}</div>
              <div class="ueberschrift-titel">{{ ueberschrift.tit }}</div>
            </div>
          </div>
          <a :href="'/' + norm.url" class="normlist-item" :title="norm.titel">
            <span class="norm-nr">{{ norm.nr }}</span><span class="norm-titel">{{ norm.titel }}</span>
          </a>
        </div>
      </div>
    </div>
    <div class="small-12 medium-8 cell gesetzContainer_main" ref="scrollview" :class="{ loading: loading, top: top, bottom: bottom }">
      <div v-for="norm in cNorms"
           v-html="norm.html"
           class="n"
           ref="norms"
           v-observe-visibility="{ callback: (isVisible, entry) => visibilityChanged(isVisible, entry, norm), throttle: 500, }">
      </div>
    </div>
    <div
      v-if="activeHighlightComment !== null"
      ref="highlightPopover"
      class="lx-highlight-comment-popover"
      :class="{ 'lx-highlight-comment-popover-empty': !activeHighlightHasContent }"
      :style="activeHighlightPopoverStyle"
      role="dialog"
      aria-modal="false"
      @click.stop>
      <p class="lx-highlight-comment-title" :style="highlightPopoverTitleStyle()">{{ activeHighlightTitle }}</p>
      <button type="button" class="lx-highlight-comment-close" :style="highlightPopoverCloseStyle()" @click.stop="dismissHighlightComment">×</button>
      <p class="lx-highlight-comment-text" :style="highlightPopoverTextStyle()">{{ activeHighlightComment }}</p>
    </div>
    <div class="registrationWall">
      <h3 class="registrationWall_headline">Teste LX Pro.</h3>
      <p>&nbsp;</p>
      <!--      <img class="registrationWall_illustration" src="/images/devices_illustration.png" alt="LX Gesetze auf allen Geräten nutzen" />-->
      <ul class="registrationWall_bulletpoints">
        <li><img src="/images/checkmark_bulletpoint.png" />Zugriff auf alle Gesetze und Funktionen.</li>
        <li><img src="/images/checkmark_bulletpoint.png" />Teste <a href="/features">LX Pro</a> auf all deinen Geräten – kostenlos und unverbindlich.</li>
        <li><img src="/images/checkmark_bulletpoint.png" />Der Testzeitraum endet automatisch.</li>
      </ul>
      <a class="button" href="/users/sign_up" @click="pwk('Regwall', 'Click')">Jetzt {{ trialLengthDays }} Tage testen</a>
      <div class="registrationWall_footer">
        Du hast schon ein Nutzerkonto?<br>
        <a class="lx-a" href="/users/sign_in">Hier einloggen</a>.
      </div>
      <a class="close" href="/">×</a>
    </div>
    <div class="paywall">
      <h3 class="registrationWall_headline">Alle Gesetze.<br>Ein Preis.</h3>
      <p>&nbsp;</p>
      <!--      <img class="registrationWall_illustration" src="/images/devices_illustration.png" alt="LX Gesetze auf allen Geräten nutzen" />-->
      <ul class="registrationWall_bulletpoints">
        <li><img src="/images/checkmark_bulletpoint.png" />Zugriff auf alle Gesetze und Funktionen.</li>
        <li><img src="/images/checkmark_bulletpoint.png" />Nutze <a href="/features">LX Pro</a> auf all deinen Geräten.</li>
      </ul>
      <a class="button" href="/lxpro" @click="pwk('Paywall', 'Click')">LX Pro aktivieren</a>
      <a class="close" href="/">×</a>
    </div>
  </div>
</template>

<script>
import debounce from "debounce";
import throttle from "lodash.throttle";

export default {
  data: function() {
    return {
      loading: false,
      law: { gesetz: {}, norms: [] },
      bottom: false,
      top: false,
      initialNormCount: 5,
      firstnorm: 0,
      lastnorm: 9,
      scrolling: false,
      scrollingup: false,
      pageHeight: 0,
      pageHeightNew: 0,
      firstload: true,
      currentURL: "",
      firstVisibleNorm: {},
      activeNorm: {},
      normlistVisible: false,
      padding: { small: 15, medium: 25, large: 35 },
      loadCycles: 0,
      block: null,
      trialLengthDays: null,
      commentByUuid: {},
      commentById: {},
      activeHighlightComment: null,
      activeHighlightTitle: "",
      activeHighlightHasContent: false,
      activeHighlightPopoverStyle: {},
      scrollDebouncedHandler: null,
      scrollThrottledHandler: null,
      viewportResizeHandler: null
    };
  },
  methods: {
    baseHighlightPopoverStyle() {
      return {
        position: "fixed",
        zIndex: "60",
        minWidth: "min(200px, calc(100vw - 24px))",
        maxWidth: "min(560px, calc(100vw - 24px))",
        width: "max-content",
        padding: "18px 44px 16px 22px",
        background: "#ffffff",
        border: "1px solid #d8dee7",
        borderRadius: "16px",
        boxShadow: "0 8px 22px rgba(20, 28, 41, 0.18)"
      };
    },
    highlightPopoverTitleStyle() {
      return {
        margin: "0 0 14px 0",
        color: "#9aa8b9",
        fontSize: "12pt",
        lineHeight: "1.25",
        fontWeight: "400"
      };
    },
    highlightPopoverCloseStyle() {
      return {
        position: "absolute",
        top: "13px",
        right: "16px",
        border: "0",
        background: "transparent",
        color: "#9aa8b9",
        fontSize: "24px",
        fontWeight: "400",
        lineHeight: "1",
        cursor: "pointer",
        padding: "0",
        width: "20px",
        height: "20px"
      };
    },
    highlightPopoverTextStyle() {
      return {
        margin: "0",
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
        color: this.activeHighlightHasContent ? "#3b3e45" : "#9aa8b9",
        fontSize: "12pt",
        lineHeight: "1.35"
      };
    },
    storeFetchedComments(comments) {
      if (!Array.isArray(comments) || comments.length === 0) {
        return;
      }
      comments.forEach((comment) => {
        if (!comment) {
          return;
        }
        if (comment.uuid) {
          this.$set(this.commentByUuid, comment.uuid, comment.comment);
        }
        if (comment.id !== null && comment.id !== undefined) {
          this.$set(this.commentById, String(comment.id), comment.comment);
        }
      });
    },
    commentDataForHighlight(uuid, id) {
      var raw = null;
      if (uuid && this.commentByUuid[uuid] !== undefined) {
        raw = this.commentByUuid[uuid];
      } else if ((id || id === 0) && this.commentById[String(id)] !== undefined) {
        raw = this.commentById[String(id)];
      }
      var text = raw === null || raw === undefined ? "" : String(raw);
      if (text.trim().length > 0) {
        return {
          text: text,
          hasContent: true
        };
      }
      return {
        text: "(keine Anmerkung)",
        hasContent: false
      };
    },
    highlightTitleForNode(node) {
      var normLabel = "";
      if (node && node.closest) {
        var normEl = node.closest(".norm");
        var normNrEl = normEl && normEl.querySelector ? normEl.querySelector(".norm-nr") : null;
        normLabel = normNrEl && normNrEl.textContent ? String(normNrEl.textContent).trim() : "";
      }
      var lawLabel = this.law && this.law.gesetz && this.law.gesetz.id ? String(this.law.gesetz.id).trim() : "";
      var suffix = [normLabel, lawLabel].filter((part) => part.length > 0).join(" ");
      if (suffix.length > 0) {
        return `zu ${suffix}`;
      }
      return "Anmerkung";
    },
    showHighlightCommentFromNode(node, event) {
      if (!node) {
        return;
      }

      if (event && event.preventDefault) {
        event.preventDefault();
      }
      if (event && event.stopPropagation) {
        event.stopPropagation();
      }

      var uuid = node.getAttribute("data-comment-uuid");
      var id = node.getAttribute("data-comment-id");
      var commentData = this.commentDataForHighlight(uuid, id);
      this.activeHighlightComment = commentData.text;
      this.activeHighlightHasContent = commentData.hasContent;
      this.activeHighlightTitle = this.highlightTitleForNode(node);
      this.activeHighlightPopoverStyle = Object.assign({}, this.baseHighlightPopoverStyle(), { top: "-9999px", left: "-9999px" });
      this.$nextTick(() => this.positionHighlightPopover(node));
    },
    positionHighlightPopover(node) {
      if (!node || !this.$refs || !this.$refs.highlightPopover) {
        return;
      }
      var popover = this.$refs.highlightPopover;
      var anchorRect = node.getBoundingClientRect();
      var margin = 8;
      var viewportPadding = 10;
      var top = anchorRect.bottom + margin;
      var left = anchorRect.left + (anchorRect.width / 2) - (popover.offsetWidth / 2);

      left = Math.max(viewportPadding, Math.min(left, window.innerWidth - popover.offsetWidth - viewportPadding));
      if (top + popover.offsetHeight + viewportPadding > window.innerHeight) {
        top = anchorRect.top - popover.offsetHeight - margin;
      }
      top = Math.max(viewportPadding, top);

      this.activeHighlightPopoverStyle = Object.assign({}, this.baseHighlightPopoverStyle(), {
        top: `${Math.round(top)}px`,
        left: `${Math.round(left)}px`
      });
    },
    bindHighlightClickHandlers() {
      var normRefs = this.$refs && this.$refs.norms ? this.$refs.norms : [];
      var roots = Array.isArray(normRefs) ? normRefs : [normRefs];
      roots.forEach((root) => {
        if (!root || !root.querySelectorAll) {
          return;
        }
        root.querySelectorAll(".lx-comment-highlight").forEach((node) => {
          if (!node || node.dataset.lxClickBound === "1") {
            return;
          }
          node.dataset.lxClickBound = "1";
          node.addEventListener("click", (event) => this.showHighlightCommentFromNode(node, event));
        });
      });
    },
    dismissHighlightComment() {
      this.activeHighlightComment = null;
      this.activeHighlightTitle = "";
      this.activeHighlightHasContent = false;
      this.activeHighlightPopoverStyle = {};
    },
    onWindowKeydown(event) {
      if (event && event.key === "Escape") {
        this.dismissHighlightComment();
      }
    },
    onWindowPointerdown(event) {
      if (this.activeHighlightComment === null) {
        return;
      }
      var target = event && event.target;
      if (!target || !target.closest) {
        this.dismissHighlightComment();
        return;
      }
      if (target.closest(".lx-highlight-comment-popover")) {
        return;
      }
      if (target.closest(".lx-comment-highlight")) {
        return;
      }
      this.dismissHighlightComment();
    },
    normalizeMatchingText(value) {
      return String(value || "")
        .replace(/[\u00a0\u202f\u2007\u2009\u200a\u2002\u2003]/g, " ")
        .replace(/\ufeff/g, "")
        .replace(/\r/g, "\n");
    },
    highlightColorsFromMeta(meta) {
      var fallback = {
        background: "#c7ecff",
        foreground: "#1f4b6f"
      };
      if (!meta) {
        return fallback;
      }

      var background = typeof meta.color === "string" ? meta.color : fallback.background;
      var foreground = typeof meta.textcolor === "string" ? meta.textcolor : fallback.foreground;

      return { background: background, foreground: foreground };
    },
    buildRenderedTextModel(el) {
      if (!el) {
        return { text: "", indexToDom: [] };
      }

      var chars = [];
      var map = [];
      var nodeFilter = window.NodeFilter || {};
      var showText = nodeFilter.SHOW_TEXT || 4;
      var filterAccept = nodeFilter.FILTER_ACCEPT || 1;
      var filterReject = nodeFilter.FILTER_REJECT || 2;
      var acceptFilter = {
        acceptNode: function(node) {
          if (!node || !node.parentElement) {
            return filterReject;
          }
          if (node.parentElement.closest(".ueberschrifts")) {
            return filterReject;
          }
          if (node.parentElement.closest(".norm-nr")) {
            return filterReject;
          }
          return filterAccept;
        }
      };

      var walker = document.createTreeWalker(el, showText, acceptFilter, false);
      var node;
      while ((node = walker.nextNode())) {
        var value = this.normalizeMatchingText(node.nodeValue || "");
        for (var i = 0; i < value.length; i++) {
          var c = value[i];
          chars.push(c);
          map.push({ node: node, offset: i });
        }
      }

      return { text: chars.join(""), indexToDom: map };
    },
    escapeRegExp(string) {
      return String(string || "").replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    },
    findBestMarkedRange(renderedText, marked, anchorStart, context) {
      if (!renderedText || !marked) {
        return null;
      }

      var safeMarked = this.normalizeMatchingText(marked);
      if (!safeMarked.length) {
        return null;
      }

      var tokenized = safeMarked.trim().split(/\s+/).filter((t) => t.length > 0);
      var patterns = [];

      // strict whitespace-only tolerance
      patterns.push(this.escapeRegExp(safeMarked).replace(/\s+/g, "\\s+"));

      // sentence-counter tolerance between words (e.g. inserted <sup>1</sup>)
      if (tokenized.length > 1) {
        patterns.push(tokenized.map((t) => this.escapeRegExp(t)).join("(?:\\s|\\d)*"));
      }

      var safeContext = this.normalizeMatchingText(context);
      if (safeContext.length) {
        var contextTokens = safeContext.trim().split(/\s+/).filter((t) => t.length > 0);
        var contextPatterns = [];

        contextPatterns.push(this.escapeRegExp(safeContext).replace(/\s+/g, "\\s+"));
        if (contextTokens.length > 1) {
          contextPatterns.push(contextTokens.map((t) => this.escapeRegExp(t)).join("(?:\\s|\\d)*"));
        }

        for (var contextPattern of contextPatterns) {
          var contextRegex;
          try {
            contextRegex = new RegExp(contextPattern, "g");
          } catch (error) {
            continue;
          }

          var contextMatch;
          while ((contextMatch = contextRegex.exec(renderedText)) !== null) {
            var realContext = contextMatch[0];
            for (var markedPattern of patterns) {
              var markedMatch = realContext.match(new RegExp(markedPattern));
              if (markedMatch && Number.isInteger(markedMatch.index)) {
                return {
                  start: contextMatch.index + markedMatch.index,
                  end: contextMatch.index + markedMatch.index + markedMatch[0].length
                };
              }
            }

            if (contextMatch.index === contextRegex.lastIndex) {
              contextRegex.lastIndex++;
            }
          }
        }
      }

      var matches = [];

      patterns.forEach((pattern) => {
        var regex;
        try {
          regex = new RegExp(pattern, "g");
        } catch (error) {
          return;
        }

        var match;
        while ((match = regex.exec(renderedText)) !== null) {
          matches.push({ start: match.index, end: match.index + match[0].length });
          // avoid zero-length loops
          if (match.index === regex.lastIndex) {
            regex.lastIndex++;
          }
        }
      });

      if (matches.length > 1) {
        // de-duplicate identical ranges from multiple patterns
        var dedup = {};
        matches = matches.filter((m) => {
          var k = `${m.start}:${m.end}`;
          if (dedup[k]) {
            return false;
          }
          dedup[k] = true;
          return true;
        });
      }
      if (matches.length === 0) {
        return null;
      }

      var anchor = Number.isInteger(anchorStart) ? anchorStart : 0;
      var after = matches.filter((m) => m.start >= anchor);
      if (after.length > 0) {
        return after.sort((a, b) => a.start - b.start)[0];
      }

      return matches.sort((a, b) => Math.abs(a.start - anchor) - Math.abs(b.start - anchor))[0];
    },
    wrapMappedRange(model, start, end, meta) {
      if (!model || !model.indexToDom) {
        return false;
      }
      if (!Number.isInteger(start) || !Number.isInteger(end) || end <= start) {
        return false;
      }

      var colors = this.highlightColorsFromMeta(meta);
      var segments = [];
      var current = null;

      for (var i = start; i < end; i++) {
        var mapped = model.indexToDom[i];
        if (!mapped || !mapped.node) {
          continue;
        }

        if (!current) {
          current = { node: mapped.node, start: mapped.offset, end: mapped.offset + 1 };
          continue;
        }

        if (current.node === mapped.node && mapped.offset === current.end) {
          current.end = mapped.offset + 1;
        } else {
          segments.push(current);
          current = { node: mapped.node, start: mapped.offset, end: mapped.offset + 1 };
        }
      }
      if (current) {
        segments.push(current);
      }
      if (segments.length === 0) {
        return false;
      }

      var touched = false;
      for (var s = segments.length - 1; s >= 0; s--) {
        var segment = segments[s];
        var node = segment.node;
        if (!node || !node.parentNode) {
          continue;
        }

        var value = node.nodeValue || "";
        var before = value.slice(0, segment.start);
        var middle = value.slice(segment.start, segment.end);
        var after = value.slice(segment.end);
        if (!middle.length) {
          continue;
        }

        var fragment = document.createDocumentFragment();
        if (before.length > 0) {
          fragment.appendChild(document.createTextNode(before));
        }

        if (/\S/.test(middle)) {
          var span = document.createElement("span");
          span.className = "lx-comment-highlight";
          span.style.setProperty("--lx-highlight-bg", colors.background);
          span.style.color = colors.foreground;
          if (meta && meta.uuid) {
            span.setAttribute("data-comment-uuid", meta.uuid);
          }
          if (meta && (meta.id || meta.id === 0)) {
            span.setAttribute("data-comment-id", String(meta.id));
          }
          span.textContent = middle;
          fragment.appendChild(span);
        } else {
          fragment.appendChild(document.createTextNode(middle));
        }

        if (after.length > 0) {
          fragment.appendChild(document.createTextNode(after));
        }

        node.parentNode.replaceChild(fragment, node);
        touched = true;
      }

      return touched;
    },
    highlightRangeInElement(el, start, end, meta) {
      if (!el) {
        return false;
      }
      if (!Number.isInteger(start) || !Number.isInteger(end) || end <= start) {
        return false;
      }
      if (!meta || !meta.marked) {
        return false;
      }

      var model = this.buildRenderedTextModel(el);
      if (!model || !model.indexToDom) {
        return false;
      }

      var matchedRange = this.findBestMarkedRange(model.text, meta.marked, start, meta.context);
      if (!matchedRange) {
        return false;
      }

      return this.wrapMappedRange(model, matchedRange.start, matchedRange.end, meta);
    },
    applyCommentHighlights(html, highlightRanges) {
      if (!html) {
        return html;
      }
      if (!highlightRanges || highlightRanges.length === 0) {
        return html;
      }

      var host = document.createElement("div");
      host.innerHTML = html;

      var root = host.firstElementChild || host;
      highlightRanges
        .slice()
        .sort((a, b) => b.start - a.start)
        .forEach((range) => {
          this.highlightRangeInElement(root, range.start, range.end, range);
        });

      return host.innerHTML;
    },
    bottomVisible() {
      const scrollY = this.$refs.scrollview.scrollTop;
      const visible = this.$refs.scrollview.clientHeight;
      const pageHeight = this.$refs.scrollview.scrollHeight;
      const bottomOfPage = visible + scrollY >= pageHeight - 1000;

      // console.log('scrollY: ', scrollY, 'visible: ', visible, 'pageHeight: ', pageHeight, 'bottomOfPage: ', bottomOfPage)

      return bottomOfPage || pageHeight < visible;
    },
    topOfPage() {
      return this.$refs.scrollview.scrollTop <= 300;
    },
    fetchNorms(norms, top) {
      this.loading = true;

      var urls = [];
      for (var i = 0; i < norms.length; i++) {
        if (this.law.norms[norms[i]] === undefined) {
          continue;
        }
        urls[i] = ["/" + this.law.norms[norms[i]].url + "/json", norms[i]];
      } // create array of urls from norms array

      if (urls.length === 0) {
        this.loading = false;
      }

      urls.forEach((url) => {
        fetch(url[0])
          .then((response) => {
            return response.json();
          })
          .then((result) => {
            this.storeFetchedComments(result.comments);
            var highlightedHtml = this.applyCommentHighlights(result.html, result.highlight_ranges);
            if (top) {
              this.scrollingup = true;
              this.pageHeight = this.$refs.scrollview.scrollHeight;
              this.law.norms[url[1]].html = highlightedHtml;
            } else {
              this.law.norms[url[1]].html = highlightedHtml;
            }
            this.$nextTick(() => this.bindHighlightClickHandlers());
            this.loading = false;
          });
      });
    },
    visibilityChanged(isVisible, entry, thisnorm) {
      //console.log('viz changed')
      thisnorm.isVisible = isVisible;

      if (this.firstload) {
        this.computeActiveNorm();
      }
    },
    rmvBrackets(string) {
      return string.replace(/\(.*?\)/, "");
    },
    computeActiveNorm() {
      let visibleNorms = this.law.norms.filter(n => n.isVisible);
      if (visibleNorms === undefined) {
        return;
      }

      this.firstVisibleNorm = visibleNorms[0];

      if (visibleNorms.length > 0) {
        this.law.norms.forEach(n => n.isActive = false);
      }
      if (visibleNorms.length === 1) {
        visibleNorms[0].isActive = true;
      } else if (visibleNorms.length > 1) {
        visibleNorms[1].isActive = true;
      }
      this.activeNorm = visibleNorms.filter(n => n.isActive)[0];
      // console.log('active: ', this.law.norms.filter( n => n.isActive))
    },
    getUrl(id) {
      return "/" + id.replace("_", "/");//.toLowerCase()
    },
    scrollDebounced() {
      // console.log('scrollingDebounced')
      this.computeActiveNorm();
    },
    updateViewportHeight() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    },
    scrollThrottled() {
      // console.log('scrollingThrottled')

      // this.computeActiveNorm()

      if (this.activeNorm === undefined) {
        return;
      } //maybe this needs to be later

      this.bottom = this.bottomVisible();
      this.top = this.topOfPage();
      this.scrolling = true;

      let currentURL = "/" + this.activeNorm.url;

      if (currentURL != this.currentURL && this.$mq !== "small") {
        this.$refs.active[0].scrollIntoView(/*{block: "start", behavior: "smooth"}*/);
        window.history.pushState(
          "object or string",
          "Title",
          currentURL
        );
      }
      this.currentURL = currentURL;

      setTimeout(() => {
        this.scrolling = false;
      }, 500);
    },
    toggleNormlist() {
      if (this.$mq !== "small") {
        return;
      }
      this.computeActiveNorm;
      this.normlistVisible = !this.normlistVisible;
      this.$refs.active[0].scrollIntoView();
    },
    cookieValue() {
      return document.cookie.replace(/(?:(?:^|.*;\s*)lx_showRegistrationWall\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    },
    pwk(catergory, event) {
      _paq.push(["trackEvent", catergory, event]);
    }
  },
  computed: {
    cNorms() {
      return this.law.norms.filter(n => n.html.length > 1);
    },
    cPadding() {
      if (this.$mq === "small") {
        return this.padding.small;
      } else if (this.$mq === "medium") {
        return this.padding.medium;
      } else {
        return this.padding.large;
      }
    },
    showRegistrationWall() {
      if ((this.loadCycles > 2 && this.block === "reg")) {  // || (this.cookieValue() === 'true' && this.block === 'reg') ) {
        // document.cookie = "lx_showRegistrationWall=true";
        this.pwk("Regwall", "Show");
        return true;
      } else {
        return false;
      }
    },
    showPaywall() {
      if (this.loadCycles > 2 && this.block === "pay") {
        this.pwk("Paywall", "Show");
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    scrolling: function(scrolling) {
      if (this.bottom && !this.loading) { // scrolling down
        this.loading = true;
        this.fetchNorms([this.lastnorm + 1, this.lastnorm + 2, this.lastnorm + 3], false);
        this.lastnorm = this.lastnorm + 3;

        this.loadCycles++;
      }
      if (this.top && !this.loading) { // scrolling up
        if (this.firstnorm == 0) { // already on top
          return;
        } else {
          this.firstnorm--;
          this.fetchNorms([this.firstnorm - 1, this.firstnorm], true);

          this.loadCycles++;
        }
      }
    }
  },
  updated() {
    //console.log("updated")
    if (this.scrollingup) {
      this.pageHeightNew = this.$refs.scrollview.scrollHeight;
      if (this.pageHeightNew > this.pageHeight) {
        this.$refs.scrollview.scrollBy(0, this.pageHeightNew - this.pageHeight);
      }
      this.scrollingup = false;
    }

    if (this.firstload && this.firstVisibleNorm !== undefined) {
      //console.log('firstload')
      this.computeActiveNorm();
      if (this.$mq !== "small" && this.$refs.active !== undefined && this.firstnorm !== 0) {
        this.$refs.active[0].scrollIntoView();
      }
      if (this.firstnorm !== 0) { // if not top of page  this.law.norms[0].isVisible === false

        if (this.$refs.norms === undefined || this.$refs.norms[1] === undefined) {
          return;
        }

        this.$refs.norms[1].getElementsByClassName("norm-nr")[0].scrollIntoView();
        if (this.$mq === "small") {
          this.$refs.scrollview.scrollBy(0, 25);
        } else {
          this.$refs.scrollview.scrollBy(0, -this.padding.medium);
        }
      }
      if (this.firstVisibleNorm !== undefined) {
        this.firstload = false;
      }
    }
  },
  created() {
    //console.log("loading")
    this.loading = true;

    var law_url = "/" + document.getElementById("wrapper").dataset.law + ".json"; // generate law url
    //this.token = $('[name="csrf-token"]').attr('content')
    this.block = document.getElementById("wrapper").dataset.block;
    this.trialLengthDays = document.getElementById("wrapper").dataset.trialLengthDays;

    var fetches = [
      fetch(law_url).then(result => result.json()) // fetch law.json
    ];
    Promise.all(fetches).then((results) => {
      this.law = results[0];

      var normid = document.getElementById("wrapper").dataset.norm.split("/")[1]; // get norm id

      this.firstnorm = this.law.norms.findIndex(function(norm) {
        return norm.id.split("_")[1] === normid;
      }); // find norm in law and set firstnorm to its index
      this.lastnorm = this.firstnorm + this.initialNormCount - 1;

      var nums = [];
      for (var i = this.firstnorm - 1; i < this.firstnorm + this.initialNormCount; i++) {
        nums.push(i);
      } // create array of numbers from firstnorm to initialNormCount
      this.fetchNorms(nums, false); // fetch array of nums

      var vm = this;
      this.law.norms.forEach(function(norm) {
        vm.$set(norm, "html", "");
        vm.$set(norm, "isVisible", false);
        vm.$set(norm, "isActive", false);
      });

      this.loading = false;
      //console.log("loading finished")
    });
  },
  mounted() {
    //console.log("mounted")
    this.scrollDebouncedHandler = debounce(this.scrollDebounced, 250);
    this.scrollThrottledHandler = throttle(this.scrollThrottled, 500);
    this.$refs.scrollview.addEventListener("scroll", this.scrollDebouncedHandler);
    this.$refs.scrollview.addEventListener("scroll", this.scrollThrottledHandler);
    window.addEventListener("keydown", this.onWindowKeydown);
    window.addEventListener("pointerdown", this.onWindowPointerdown);
    this.viewportResizeHandler = this.updateViewportHeight;
    this.updateViewportHeight();
    window.addEventListener("resize", this.viewportResizeHandler);
  },
  beforeDestroy() {
    if (this.$refs.scrollview) {
      this.$refs.scrollview.removeEventListener("scroll", this.scrollDebouncedHandler);
      this.$refs.scrollview.removeEventListener("scroll", this.scrollThrottledHandler);
    }
    if (this.scrollDebouncedHandler && this.scrollDebouncedHandler.clear) {
      this.scrollDebouncedHandler.clear();
    }
    if (this.scrollThrottledHandler && this.scrollThrottledHandler.cancel) {
      this.scrollThrottledHandler.cancel();
    }
    window.removeEventListener("keydown", this.onWindowKeydown);
    window.removeEventListener("pointerdown", this.onWindowPointerdown);
    window.removeEventListener("resize", this.viewportResizeHandler);
  }
};
</script>

<style scoped>
.active {
  font-weight: bold;
}

.lx-highlight-comment-popover {
  position: fixed;
  min-width: min(30rem, calc(100vw - 24px));
  max-width: min(42rem, calc(100vw - 24px));
  width: max-content;
  min-height: 12rem;
  z-index: 60;
  padding: 1.55rem 4.1rem 1.65rem 1.75rem;
  background: #ffffff;
  border: 1px solid #d8dee7;
  border-radius: 1.9rem;
  box-shadow: 0 8px 22px rgba(20, 28, 41, 0.18);
}

.lx-highlight-comment-popover-empty {
  min-height: 11rem;
}

.lx-highlight-comment-title {
  margin: 0 0 1.4rem;
  color: #95a1b3;
  font-size: 2.6rem;
  line-height: 1.15;
  font-weight: 600;
}

.lx-highlight-comment-close {
  position: absolute;
  top: 1.1rem;
  right: 1.1rem;
  border: 0;
  width: 2.9rem;
  height: 2.9rem;
  border-radius: 50%;
  background: #9aa6b7;
  color: #ffffff;
  font-size: 2.25rem;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.12s ease;
}

.lx-highlight-comment-close:hover,
.lx-highlight-comment-close:focus {
  background: #7f8ca0;
}

.lx-highlight-comment-text {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
  color: #3b3e45;
  font-size: 2.8rem;
  line-height: 1.33;
}

.lx-highlight-comment-popover-empty .lx-highlight-comment-text {
  color: #95a1b3;
}

@media (min-width: 640px) {
  .gesetzContainer_main {
    height: 100%;
  }
}
</style>
